"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _Icon = _interopRequireDefault(require("./_internal/Icon"));
var DownArrow2Outlined = /*#__PURE__*/_react["default"].forwardRef(function (ddProps, ref) {
  var props = {};
  var svg = /*#__PURE__*/_react["default"].createElement("svg", (0, _extends2["default"])({
    className: "dt__icon",
    viewBox: "0 0 1024 1024",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    "aria-hidden": "true"
  }, props), /*#__PURE__*/_react["default"].createElement("defs", null), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M899.093 294.165a42.667 42.667 0 014.139 57.515l-2.41 2.773-347.009 367.574a64 64 0 01-90.453 2.624l-2.603-2.582-347.306-367.573a42.667 42.667 0 0159.392-61.184l2.645 2.56 331.797 351.147 331.478-351.147a42.667 42.667 0 0157.536-4.139l2.773 2.432z"
  }));
  return /*#__PURE__*/_react["default"].createElement(_Icon["default"], (0, _extends2["default"])({}, ddProps, {
    svg: svg,
    ref: ref
  }));
});
DownArrow2Outlined.displayName = "DownArrow2Outlined";
var _default = exports["default"] = DownArrow2Outlined;